import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";

function State() {
  const navigate = useNavigate();
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>State</div>
          <div>
            <button
              className="btn btn-labeled btn-success"
              type="button"
              style={{ fontSize: "17px" }}
              onClick={() => navigate("/admin/state/new")}
            >
              <span className="btn-label">
                <em className="fas fa-plus"></em>
              </span>
              New State
            </button>
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default State;
